<template>
  <div class="no-results">
    <div class="content-panel panel">
      <h6 class="no-results--heading">
        Oppps! Non abbiamo trovato proposte per la tua ricerca. Che fare?
      </h6>
      <b-row>
        <b-col md="4">
          <div class="no-results--item">
            <vb-icon name="filters"></vb-icon>
            <div class="no-results--title">Elimina i filtri</div>
            <div class="no-results--text">
              Hai inserito troppi filtri?
              <br />
              Prova con meno filtri.
            </div>
          </div>
        </b-col>
        <b-col md="4">
          <div class="no-results--item">
            <vb-icon name="calendar"></vb-icon>
            <div class="no-results--title">Prova su altre date</div>
            <div class="no-results--text">
              Le compagnie low cost hanno ridotto il numero di voli settimanali
              per cui prova tutti i giorni della settimana.
            </div>
          </div>
        </b-col>
        <b-col md="4">
          <div class="no-results--item">
            <vb-icon name="pin"></vb-icon>
            <div class="no-results--title">Usa il nome della città</div>
            <div class="no-results--text">
              Non usare il nome dell'aeroporto (ex. Malpensa o MXP) ma il nome
              della città (Tutti gli aeroporti di Milano).
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "no-results",
};
</script>

<style lang="scss">
.no-results {
  text-align: center;
  margin-bottom: $grid-gutter-width;
  .panel {
    padding: $grid-gutter-width $grid-gutter-width;
  }
  &--heading {
    @extend .h6 !optional;
    margin-bottom: $grid-gutter-width;
  }
  &--icon {
    margin-bottom: 8px;
  }
  &--title {
    font-size: 16px;
  }
  &--text {
    font-size: 12px;
    max-width: 200px;
    margin: 0 auto;
  }
  &--item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }
}
</style>
